export const getShortOrderCode = (code: string) =>
    Number(code.substring(code.length - 3)).toString()
